import React from 'react';
import { BrandButton, useTailwindBrand } from 'src/Components/shared';
import ButtonField from 'src/Components/Ui/ButtonField';

interface LayoutProcurationProps {
    title: string;
    icon: React.ReactNode;
    nextLabel?: string;
    prevLabel?: string;
    classBtnPrev?: string;
    nextStep: () => void;
    prevStep: () => void;
    children: React.ReactNode;
    currentStep?: number; // Pour la pagination (1-4)
    totalSteps?: number; // Total des pages (4)
    loading?: boolean;
}


const LayoutProcuration = (props: LayoutProcurationProps) => {
    const { classes, common } = useTailwindBrand();
    const { title, icon, nextLabel, prevLabel, nextStep, prevStep, children, classBtnPrev, currentStep, totalSteps, loading } = props;
    const showPagination = currentStep !== undefined && totalSteps !== undefined;
    
    return (
        <div className="w-full h-full flex flex-col">
            {/* Header */}
            <div className="flex-shrink-0">
                <div className="flex items-center justify-between gap-3 mb-8">
                    <div className="flex items-center gap-3">
                        <div className="hidden lg:flex items-center justify-center w-10 h-10 rounded-full bg-blue-50">
                            {icon}
                        </div>
                        <h2 className={`${classes.primaryText} ${classes.fontFamily} ${common.subtitle2} text-lg lg:/text-3xl font-bold`}>
                            {title}
                        </h2>
                    </div>
                    {showPagination && (
                        <span className={`text-sm font-medium ${classes.text} ${classes.fontFamily} bg-gray-100 px-3 py-1.5 rounded-full`}>
                            {currentStep}/{totalSteps}
                        </span>
                    )}
                </div>
            </div>
            
            {/* Content Area - Scrollable */}
            <div className="flex-1 z-40 /overflow-y-auto space-y-8 p-1">
                {children}
            </div>
            
            {/* Footer - Fixed at bottom */}
            <div className="flex justify-end pt-3 border-t border-gray-200 mt-3 flex-shrink-0">
                <div className="flex flex-col lg:flex-row w-full justify-between lg:gap-x-4 gap-y-4 /space-y-4" >
                    <ButtonField
                        label={prevLabel ?? 'Précédent'}
                        variant="outlined"
                        className={`w-full font-bold lg:w-auto ${classBtnPrev}`}
                        onClick={prevStep}
                    />
                    <ButtonField
                        label={nextLabel ?? 'Suivant'}
                        variant="contained"
                        className="w-full font-bold lg:w-auto"
                        onClick={nextStep}
                        disabled={loading}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default LayoutProcuration;